module.exports = __webpack_public_path__ + "static/img/u70049.1d471719.png";